import { IconProps, iconColor } from './IconProps'

export function CircleCloseLineIcon(props: IconProps) {
  const size = props.size || 24

  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8.29289 8.29289C8.68342 7.90237 9.31658 7.90237 9.70711 8.29289L11.9999 10.5857L14.2928 8.29289C14.6833 7.90237 15.3165 7.90237 15.707 8.29289C16.0975 8.68342 16.0975 9.31658 15.707 9.70711L13.4141 11.9999L15.707 14.2928C16.0975 14.6833 16.0975 15.3165 15.707 15.707C15.3165 16.0975 14.6833 16.0975 14.2928 15.707L11.9999 13.4141L9.70711 15.707C9.31658 16.0975 8.68342 16.0975 8.29289 15.707C7.90237 15.3165 7.90237 14.6833 8.29289 14.2928L10.5857 11.9999L8.29289 9.70711C7.90237 9.31658 7.90237 8.68342 8.29289 8.29289Z'
        fill={iconColor(props)}
      />
    </svg>
  )
}
